import { Chart } from '@frontend/chart/types';

export const EQUIPMENT_TIMERS_DURATION_BY_EQUIPMENT_LIST_CHART_MOCK_DATA: Chart = {
    series: [
        { name: 'Drill-A12', data: [{ label: 'full_period', value: 86400 }] },
        { name: 'Laptop-B3', data: [{ label: 'full_period', value: 72000 }] },
        { name: 'Meter-C7', data: [{ label: 'full_period', value: 54000 }] },
        { name: 'Camera-D1', data: [{ label: 'full_period', value: 36000 }] },
        { name: 'Radio-E9', data: [{ label: 'full_period', value: 18000 }] }
    ]
};
